import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ThankYouPage = () => {
  const location = useLocation();
  const name = location.state?.name || 'there';

  return (
    <>
      <TopBar />
      <Navbar />
      
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        .thankyou-wrapper {
          padding: 120px 20px;
          text-align: center;
          min-height: 60vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #f8fafc;
          font-family: 'Inter', sans-serif;
        }
        .thankyou-icon {
          width: 96px; height: 96px;
          background: linear-gradient(135deg, #ecfdf5, #d1fae5);
          color: #10b981;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 44px;
          margin: 0 auto 24px;
          border: 4px solid #a7f3d0;
          box-shadow: 0 16px 32px rgba(16, 185, 129, 0.2);
          animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
        }
        @keyframes scaleIn {
          0% { transform: scale(0); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        .thankyou-title {
          font-size: 36px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 16px;
          letter-spacing: -0.5px;
        }
        .thankyou-text {
          font-size: 18px;
          color: #475569;
          max-width: 500px;
          margin: 0 auto 32px;
          line-height: 1.6;
        }
        .thankyou-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 32px;
          background: #061830;
          color: white;
          border-radius: 50px;
          font-size: 16px;
          font-weight: 700;
          text-decoration: none;
          box-shadow: 0 10px 24px rgba(6, 24, 48, 0.2);
          transition: transform 0.2s, background 0.2s;
        }
        .thankyou-btn:hover {
          transform: translateY(-2px);
          background: #CFA047;
          color: white;
        }
      `}</style>
      
      <div className="thankyou-wrapper">
        <div className="thankyou-icon">
          <i className="fa-solid fa-check"></i>
        </div>
        <h1 className="thankyou-title">Thank You, {name}!</h1>
        <p className="thankyou-text">
          Your request was received successfully. A legal expert will contact you shortly to assist you with your query. We appreciate you reaching out to us!
        </p>
        <Link to="/" className="thankyou-btn">
          Back to Home <i className="fa-solid fa-arrow-right"></i>
        </Link>
      </div>

      <Footer />
    </>
  );
};

export default ThankYouPage;
